import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VRow,{staticClass:"mx-4 mt-2"},[(_vm.isShow)?_c('p',{staticClass:"body-2 memberid-red--text font-weight-bold"},[_vm._v("・"+_vm._s(_vm.message))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }